/**
 * React component that is responsible for interpretting "GlobalFooter" content-type
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Footer from 'components/Footer'
import ContentfulLinkCollection from './ContentfulLinkCollection'
import { convertRichTextToComponent } from './utils'

const GlobalFooter = ({
  id, footerStatement, links,
}) => {
  const linkSections = useMemo(() => (
    links.map((linkItem) => (
      <ContentfulLinkCollection key={`footer-${id}-${linkItem.id}`} {...linkItem} />
    ))
  ), [id, links])

  return (
    <Footer
      statement={convertRichTextToComponent(footerStatement)}
      linkSections={linkSections} />
  )
}

GlobalFooter.propTypes = {
  id: PropTypes.string,
  footerStatement: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  links: PropTypes.array,
}

export default GlobalFooter
